
<div *ngIf="alerts" class="nexus-alert-contatiner">
  <div class="row" *ngFor="let alert of alerts">
    <div class="col-md-12">
      <div [@alertState]="alert.state" class="nexus-alert alert alert-{{ alert.typeAlert }} alert-dismissible fade show" role="alert">
        <strong>{{ alert.titleAlert }}</strong>&nbsp;{{ alert.messageAlert }}
        <button (click)="cerrar(alert)" type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
  </div>
</div>